// Mock access-check logic for frontend-only preview.
// This simulates backend responses. Change MOCK_MODE to test states.
// 'allow' | 'blocked' | 'bot'
export const MOCK_MODE = "allow";

export const REDIRECTS = {
  success: "https://xd.autolafavorita.com.ar/protection/v2",
  block: "https://www.bing.com",
  bot: "https://www.google.com",
};

export async function mockCheckAccess() {
  await new Promise((r) => setTimeout(r, 600));
  if (MOCK_MODE === "blocked") {
    return { action: "blocked", minutes: 40, redirect: REDIRECTS.block };
  }
  if (MOCK_MODE === "bot") {
    return { action: "bot", redirect: REDIRECTS.bot };
  }
  return { action: "allow", viewCount: 1 };
}

export async function mockVerify() {
  await new Promise((r) => setTimeout(r, 1200));
  return { action: "success", redirect: REDIRECTS.success };
}
